import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './styles/tool-tip.scss';
import View from '@loggi/ui/components/view';
import Text from '@loggi/ui/components/text';

function ToolTip({ label, className }) {
  return (
    <View className={classNames(styles.toolTip, className)}>
      <Text bold>{label}</Text>
    </View>
  );
}

ToolTip.propTypes = {
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  className: PropTypes.string
};

export default ToolTip;
